/* eslint-disable prettier/prettier */
import React from 'react';

import mentorIcon from '../../../../assets/profile/dd1.png';
import assignmentIcon from '../../../../assets/profile/dd2.png';
import sessionIcon from '../../../../assets/profile/dd3.png';
import eye from '../../../../assets/profile/View.png';

import styles from './CoachDashboardActivity.module.css';

import ActivitySection from '../admin/ActivitySection';

import { useCoachActionCenter } from '../../../../hooks/useCoachActionCenter';
import { useNavigate } from 'react-router-dom';

const CoachDashboardActivity = () => {
	const navigate = useNavigate();

	const {
		data,
		loading,
		error,

		recentActivityData,
		recentActivityLoading,
		recentActivityError,
	} = useCoachActionCenter();

	const recentItems =
		recentActivityData?.items?.map(item => ({
			leftIcon:
				item.activitytype === 'course-completed'
					? assignmentIcon
					: item.activitytype === 'submission-received'
						? mentorIcon
						: sessionIcon,

			leftIconBg:
				item.activitytype === 'course-completed'
					? '#F8E8F2'
					: item.activitytype === 'submission-received'
						? '#DFF5EF'
						: '#FFF1E8',

			title: item.description,

			rightText: new Date(item.createdat).toLocaleDateString(),
		})) || [];

	const getActionTitle = (count: number | undefined, label: string) => {
		return count && count > 0 ? `${count} ${label}` : `No ${label}`;
	};

	return (
		<div className={styles.wrapper}>
			{/* ACTION CENTER */}
			<div className={styles.left}>
				<ActivitySection
					title="ACTION CENTER"
					items={[
						{
							leftIcon: mentorIcon,
							leftIconBg: '#DFF5EF',

							title: getActionTitle(
								data?.pendingsubmissions,
								'Pending Submissions'
							),

							rightIcon: eye,

							onRightClick: () => {
								navigate('/dashboard/programs');
							},
						},

						{
							leftIcon: sessionIcon,
							leftIconBg: '#F8E8F2',

							title: getActionTitle(
								data?.upcomingsessions,
								'Upcoming Sessions'
							),

							rightIcon: eye,

							onRightClick: () => {
								navigate('/dashboard/programs');
							},
						},

						{
							leftIcon: mentorIcon,
							leftIconBg: '#E8F1FD',

							title: getActionTitle(
								data?.unreadmessages,
								'Unread Messages'
							),

							rightIcon: eye,

							onRightClick: () => {},
						},
					]}
					containerBg="#fff"
				/>
			</div>

			{/* RECENT ACTIVITY */}
			<div className={styles.right}>
				<ActivitySection
					title="RECENT ACTIVITY"
					items={
						recentItems.length > 0
							? recentItems
							: [
									{
										title: 'No recent activity yet',
									},
								]
					}
					containerBg="#fff"
					maxHeight="340px"
				/>
			</div>
		</div>
	);
};

export default CoachDashboardActivity;
